import useSeo from "@/hooks/useSeo";

export default function Contact() {
  useSeo({
    title: "Contact Us",
    description:
      "Contact Dietico and Mesron Healthcare LLP. Grievance Officer Dr. Indranil Chatterjee · admin@dietico.co.in · +91 9002296906. Registered office in Asansol, West Bengal.",
    path: "/contact",
  });
  return (
    <div data-testid="contact-page">
      <section className="mx-auto max-w-7xl px-6 pt-16 pb-16 md:pt-24">
        <p className="font-mono text-[11px] uppercase tracking-widest text-secondary mb-6">
          Get in touch
        </p>
        <h1 className="text-5xl md:text-7xl font-light tracking-tightest leading-[0.95] text-foreground max-w-4xl">
          For questions, grievances, or data-protection requests.
        </h1>
        <p className="mt-8 max-w-2xl text-lg text-secondary leading-relaxed">
          Dietico is operated by Mesron Healthcare LLP. All correspondence is
          handled by our Grievance Officer under the DPDP Act 2023 and the IT
          (Intermediary Guidelines) Rules 2021.
        </p>
      </section>

      {/* Bento contact grid */}
      <section className="mx-auto max-w-7xl px-6 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
          {/* Email — hero card */}
          <a
            href="mailto:admin@dietico.co.in"
            data-testid="contact-email-card"
            className="md:col-span-8 rounded-3xl border border-border bg-secondary p-10 md:p-16 group hover:bg-card transition-colors"
          >
            <p className="font-mono text-[11px] uppercase tracking-widest text-secondary mb-8">
              Write to us
            </p>
            <p className="text-3xl md:text-5xl lg:text-6xl font-light tracking-tightest text-foreground break-all">
              admin@dietico.co.in
            </p>
            <p className="mt-6 text-secondary">
              Acknowledged within 24 hours · resolved within 90 days
            </p>
          </a>

          {/* Phone */}
          <a
            href="tel:+919002296906"
            data-testid="contact-phone-card"
            className="md:col-span-4 rounded-3xl border border-border bg-secondary p-10 md:p-12 hover:bg-card transition-colors"
          >
            <p className="font-mono text-[11px] uppercase tracking-widest text-secondary mb-6">
              Call us
            </p>
            <p className="text-3xl md:text-4xl font-light tracking-tightest text-foreground">
              +91 9002296906
            </p>
            <p className="mt-6 text-secondary text-sm">Mon – Sat · 9 AM – 6 PM IST</p>
          </a>

          {/* Grievance officer */}
          <div className="md:col-span-5 rounded-3xl border border-border bg-secondary p-10">
            <p className="font-mono text-[11px] uppercase tracking-widest text-secondary mb-4">
              Grievance officer
            </p>
            <p className="text-2xl font-medium tracking-tight text-foreground">
              Dr. Indranil Chatterjee
            </p>
            <p className="mt-2 text-secondary">
              Founder &amp; Grievance Officer, Mesron Healthcare LLP
            </p>
            <p className="mt-4 text-xs text-secondary max-w-sm leading-relaxed">
              Appointed under Section 8(9) &amp; 8(10) of the DPDP Act 2023
              and Rule 3 of the IT (Intermediary Guidelines) Rules 2021.
            </p>
          </div>

          {/* Registered office */}
          <div className="md:col-span-7 rounded-3xl border border-border bg-secondary p-10">
            <p className="font-mono text-[11px] uppercase tracking-widest text-secondary mb-4">
              Registered office
            </p>
            <p className="text-xl md:text-2xl font-medium tracking-tight text-foreground leading-snug max-w-md">
              Holding Premises No. 159/63, Street No. 2,
              <br />
              Hindusthan Park, Hirapur,
              <br />
              Asansol · 713304, West Bengal, India
            </p>
            <div className="mt-6 flex flex-wrap gap-x-8 gap-y-2 font-mono text-[11px] uppercase tracking-widest text-secondary">
              <span>LLPIN · ACD-8580</span>
              <span>Incorporated · 19 Nov 2023</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
